@if (contracts()?.length > 0) {
  <div class="contracts-list">
    <p>
      {{
        'company-tool.views.jobs.posting.sections.publication.job-markets.contracts'
          | transloco
      }}
    </p>
    <ul>
      @for (contract of contracts(); track contract.contract_id) {
        <li>{{ contract.product.title }}</li>
      }
    </ul>
  </div>
}
<p
  class="mt-3 mb-3"
  [innerHTML]="
    'company-tool.views.jobs.posting.saver.publish-modal.pricing'
      | transloco
        : {
            total: (price()?.price | formatPrice),
          }
  "
></p>
<div class="channel-group">
  @for (platform of platforms(); track platform.id) {
    <div class="d-flex justify-content-between">
      <b>{{ platform.title }}</b>
      @if (isCreditsPlatform(platform.id)) {
        <span>
          {{
            'company-tool.views.jobs.posting.sections.publication.sourcing-campaign.credits'
              | transloco: { credits: (platform.price | number: '1.0-0') }
          }}
        </span>
      } @else {
        <span>{{ platform.price | formatPrice }}</span>
      }
    </div>
  }
</div>
<hr />
<div class="d-flex justify-content-between">
  <b>{{
    'company-tool.views.jobs.posting.sections.publication.job-markets.total'
      | transloco
  }}</b>
  <span>{{ price()?.price | formatPrice }}</span>
</div>
@if (price()?.price) {
  <p class="vat-note">
    {{ 'company-tool.snippets.invoice-booking.vat-note' | transloco }}
  </p>
}
